import {
  notebooksDashboardRoute,
  notebookEntriesRoute,
  notebookExperimentsRoute,
  notebooksRoute,
  notebookTemplatesRoute,
} from "../ELN/ELNRouter/ELNRouter";
import { IdTypes } from "../api/GenericTypes";

// These should reflect what the API can actually return
export type ResourceName =
  | "admin"
  | "api_keys"
  | "audit_logs"
  | "autoload_clients"
  | "bridges"
  | "data_sources"
  | "data_sources_status"
  | "autoload/is_dataset_known"
  | "autoload/dataset_manual_upload"
  | "autoload/dataset_upload"
  | "samples"
  | "persons"
  | "projects"
  | "announcements"
  | "datasets"
  | "datasets/create"
  | "datasets/update"
  | "methods"
  | "entities"
  | "lab_notebooks"
  | "lab_notebook_experiments"
  | "lab_notebook_entries"
  | "lab_notebook_templates"
  | "parsing/errors"
  | "custom_fields"
  | "vendors"
  | "data_formats"
  | "data_format_instruments"
  | "shared_content"
  | "custom_imports"
  | "custom_import_logs"
  | "origins"
  | "users"
  | "folders"
  | "users_preferences"
  | "users_preferences_global"
  | "datasets/zip_size"
  | "formats"
  | "roles"
  | "iconnmr_history_entries"
  | "iconnmr_holders"
  | "iconnmr_status"
  | "inventory_items"
  | "types"
  | "custom_type_templates"
  | "custom_field_templates"
  | "custom_type_template_packages"
  | "signatures"
  | "file_export_jobs"
  | "zontal/credentials"
  | "zontal/information_package";

// WARNING: The main routes are also defined in the backend in EntityType.cs -> EntityIndexRoute
// Make sure they are in sync!

// Here we collect any other route
export type RouteNames =
  | ResourceName
  | "viewer"
  | "autoload_monitoring"
  | "shared"
  | "table"
  | "manage"
  | "autoload_sources_FH"
  // | "autoload_sources"
  // | "autoload_configurations"
  | "bridges"
  | "data_sources"
  | "pattern_test";

export type EntityRoutes = {
  [key in RouteNames]?: string;
};

export const indexRoutes = {
  about: "about",
  admin: "admin",
  announcements: "announcements",
  apikeys: "apikeys",
  autoload_monitoring: "autoload_monitoring",
  audit_logs: "audit_logs",
  bundles: "bundles",
  bridges: "bridges",
  components: "components",
  custom_fields: "custom_fields",
  custom_imports: "custom_imports",
  custom_import_logs: "custom_import_logs",
  dashboard: "",
  data: "data",
  datasets: "datasets",
  // dataset_types: "manage/dataset_types",
  data_sources: "data_sources",
  data_sources_status: "data_sources_status",
  documents: "documents", // For legacy redirect
  experiments: "experiments", // For legacy redirect
  notebooks: `${notebooksRoute}/${notebooksDashboardRoute}`,
  formats: "formats",
  instruments: "instruments", // For legacy redirect
  iconnmr: "monitoring/iconnmr",
  inventories: "inventories",
  inventory_items: "inventories/items",
  methods: "measurement_methods",
  manage: "manage",
  maintenance: "maintenance",
  attachments: "attachments",
  lab_notebooks: notebooksRoute,
  lab_notebook_experiments: `${notebooksRoute}/${notebookExperimentsRoute}`,
  lab_notebook_entries: `${notebooksRoute}/${notebookEntriesRoute}`,
  lab_notebook_templates: `${notebooksRoute}/${notebookTemplatesRoute}`,
  persons: "persons",
  person_tags: "person_tags", // For legacy redirect
  projects: "projects",
  project_tags: "project_tags", // For legacy redirect
  roles: "roles",
  samples: "samples",
  // sample_types: "manage/sample_types",
  shared: "shared",
  shared_content: "shared_content",
  storage: "storage", // remove once facilties is migrated
  types: "types",
  organizations: "organizations", // For legacy redirect
  organization_tags: "organization_tags", // For legacy redirect
  templates: "templates", // Landing page for templates
  custom_type_templates: "custom_type_templates",
  custom_field_templates: "custom_field_templates",
  custom_type_template_packages: "custom_type_template_packages",
  uuid: "uuid",
  parser_selections: "parser_selections",
  signatures: "signatures",
  file_export_jobs: "file_export_jobs",
  zontal_credentials: "integrations/zontal",
  zontal_information_package: "integrations/zontal/information_package",

  // viewer: getIndexRoute("viewer"),
  // pattern_test: getIndexRoute("pattern_test"),
} as const;

export type RouteKey = keyof typeof indexRoutes;
export const getIndexRoute = (route: RouteKey) => `/${indexRoutes[route]}`;
export const getAddRoute = (route: RouteKey) => `/${indexRoutes[route]}/new`;
export const getBulkEditRoute = (route: RouteKey) => `/${indexRoutes[route]}/edit`;
export const getDetailRoute = (route: RouteKey) => `/${indexRoutes[route]}/:id`;
export const getEditRoute = (route: RouteKey) => `/${indexRoutes[route]}/:id/edit`;
export const getCloneRoute = (route: RouteKey) => `/${indexRoutes[route]}/:id/clone`;
export const getUUIDRoute = (route: RouteKey) => `/${indexRoutes[route]}/:uuid`;
export const getExportRoute = (route: RouteKey) => `/${indexRoutes[route]}/:id/export`;

export const getUploadedCsvFilePreviewPage = (route: RouteKey) => `/${indexRoutes[route]}/uploadedCsvFilePreviewPage`;

export const getEditLink = (route: RouteKey, id: IdTypes) => `/${indexRoutes[route]}/${id}/edit`;
export const getCloneLink = (route: RouteKey, id: IdTypes) => `/${indexRoutes[route]}/${id}/clone`;
export const getDetailLink = (route: RouteKey, id: IdTypes) => `/${indexRoutes[route]}/${id}`;
export const getUUIDLink = (uuid: string) => `/#${indexRoutes["uuid"]}/${uuid}`;
